module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_schankverlust_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text"
  }, [_vm._v("Schankverlust " + _vm._s(_vm.$filters.date(_vm.monat, "MM.YY")))])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Striche Soll (Theorie)")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.gesamtStricheTheorie))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Striche Ist (Praxis)")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.gesamtStrichePraxis))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Striche Differenz")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) + " (" + _vm._s(_vm.statistik.schankverlust) + "%)\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10% Schankverlust")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s((_vm.statistik.gesamtStricheTheorie * 0.1).toFixed(0)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("fehlende Striche")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm.statistik.gesamtStricheTheorie -
    _vm.statistik.gesamtStrichePraxis -
    (_vm.statistik.gesamtStricheTheorie * 0.1).toFixed(0)) + "\n          ")])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-3"
  }, [_c('td', [_vm._v("Fehlbetrag Schankverlust")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) * _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-3"
  }, [_c('td', [_vm._v("Fehlbetrag Schankverlust (-10%)")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie -
      _vm.statistik.gesamtStricheTheorie * 0.1 -
      _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oe-Kisten")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.oettingerKisten))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Couleurstriche")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.couleurstricheAnzahl))])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-3"
  }, [_c('td', [_vm._v("Kosten Oettinger und Couleurbier")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")((parseFloat(_vm.statistik.oettingerKistenPreis) +
    _vm.statistik.couleurstricheAnzahl * _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-1 font-weight-bold"
  }, [_c('td', [_vm._v("Summe")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")((_vm.statistik.oettingerKisten * 6.78 +
    _vm.statistik.couleurstricheAnzahl * _vm.statistik.durchschnittsStrichPreis +
    _vm.statistik.gesamtStricheTheorie -
    _vm.statistik.gesamtStrichePraxis -
    (_vm.statistik.gesamtStricheTheorie * 0.1).toFixed(0) * _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-122ff7c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/schankverlust.vue
// module id = 735
// module chunks = 15